var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"m 0,8.5 v 1 h 18 v -1 z","id":"path1452"}})}
var staticRenderFns = []

export { render, staticRenderFns }